import {Component, Input} from '@angular/core';
import {
	IWizardMissingValueData
} from '@workflow/components/navigator/missing-value-button/wizard-missing-value-button.component';
import {
	AbstractMissingValueComponent
} from '@workflow/components/navigator/missing-value-button/missing-value-button.abstract';
import {
	WorkflowItemKeyDirective
} from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-wizard-missing-value-button-element',
	templateUrl: './wizard-missing-value-button-element.component.html',
	styleUrls: [
		'./wizard-missing-value-button-element.component.scss',
	]
})
export class WizardMissingValueButtonElementComponent extends AbstractMissingValueComponent {

	_element: IWizardMissingValueData = null;
	@Input() set element(entry: IWizardMissingValueData) {
		this._element = entry;
	}

	@Input() finishedAndLocked = false;

	constructor(workflowItemKey: WorkflowItemKeyDirective) {
		super(workflowItemKey);
	}

	toggleMissingValueInMenu(): void {
		if (this.finishedAndLocked) {
			return;
		}

		this.toggleMissingValue();
	}
}
